export const columnKeyMap = {
  brand: 'transport.brand',
  model: 'transport.model',
  number: 'transport.number',
  region: 'transport.region',
  country: 'transport.country.name',
  permit: 'permit.transportPermitType.name',
  clients: 'clients',
  clientFio: 'clientFio',
  permitStatus: 'permitStatus.name',
  permitType: 'permitType.name',
  insertDate: 'insertDate',
  entryDate: 'entryDate',
  expireDate: 'expireDate',
  numberPermit: 'id',
  isRepeatPermit: 'isRepeat',
  houseNamePermit: 'houseName',
  sourcePermit: 'source.name',
  hasPermits: 'transport.hasPermits',
  transportType: 'transport.transportType.name',
};
